
export function caroussel_fullscreen({ commit }, bool ){

    commit('CAROUSSEL_FULLSCREEN',bool);
  }